import { useRef } from 'react';
import { find } from 'lodash';
import { usePlmId } from '../utilities/PgmUtilities';
import { DataServiceFactory } from './ApiDataService';
import { usePlms } from '../stores/PlmStateStore';
import { useIsPgm } from '../stores/EnvironmentStore';

const API_URL = '/api/v3/plms';

const PlmService = PlmServiceFactory();

function PlmServiceFactory() {
    const dataService = DataServiceFactory();

    async function getPlms() {
        const response = await dataService.get(`${API_URL}/list`, { limit: 100 });
        return response?.data;
    }

    async function getPlmById(plmId) {
        const response = await dataService.get(`${API_URL}/${plmId}/details`, {});
        return response?.data;
    }

    return {
        getPlms,
        getPlmById,
    };
}

export function usePlmService() {
    const [isPgm] = useIsPgm();

    const { current: dummyService } = useRef({
        getPlms: async () => null,
        getPlmById: async () => null,
    });

    return isPgm ? PlmService : dummyService;
}

export function useCurrentPlmName() {
    const [plms] = usePlms();
    const plmId = usePlmId();

    if (plms && plms.length > 0) {
        return find(plms, { id: plmId })?.name;
    }

    return null;
}
